<div class="confirm-dialog">
  <div class="modal-header">
    <h5 class="title-box">
      <i class="app-icon-tag"></i>
      Confirmar oferta personalizada
    </h5>
    <button type="button" class="close" (click)="onNoClick()">
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>

  <div class="modal-body">
    <p class="subtitle">
      A oferta personalizada não inicia uma disputa automática como uma oferta comum.
      Ela será enviada para análise do vendedor, que poderá aceitar, recusar ou responder com uma contraproposta.
    </p>

    <div class="values-box">
      <div class="value-col">
        <div class="label">Sua proposta</div>
        <div class="value">R$ {{ alternativeBid?.value | number }}</div>
      </div>

      <div class="value-col">
        <div class="label">{{ comparisonLabel }}</div>
        <div class="value highlight">R$ {{ comparisonValue | number }}</div>
      </div>
    </div>

    <app-textarea
      class="comment-field"
      appearance="floating"
      label="Comentário opcional"
      [rows]="3"
      [maxLength]="500"
      [showCount]="true"
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="alternativeBid.message"
    ></app-textarea>

    <div class="actions">
      <button class="btn btn-rounded btn-outline-primary" (click)="onNoClick()">Ajustar valor</button>
      <button class="btn btn-rounded btn-primary" (click)="onClickConfirm()">Enviar para análise</button>
    </div>
  </div>
</div>
